// Calendar presentation (primary + alternate). Storage stays canonical Gregorian YYYY-MM-DD; this only formats.
export const CALENDARS: Array<[string, string]> = [['gregory', 'Gregorian'], ['persian', 'Persian'], ['islamic-civil', 'Hijri - Civil'], ['islamic-tbla', 'Hijri - Kuwaiti'], ['islamic-umalqura', 'Hijri - Saudi'], ['hebrew', 'Hebrew'], ['chinese', 'Chinese'], ['dangi', 'Korean'], ['indian', 'Indian - Saka'], ['japanese', 'Japanese'], ['buddhist', 'Buddhist']];

/** Module-level equivalent of the prototype's window.__tpCal (set every render from preferences). */
export const calState: { p: string; a: string; loc: string } = { p: 'gregory', a: 'none', loc: 'en-US' };

export const tpCal = (): string => calState.p || 'gregory';
export const tpLoc = (): string => calState.loc || 'en-US';
/** Same text as `date.toLocaleDateString(loc, o)` / `toLocaleString(loc, o)` when `o` names date fields, but with
 *  the formatter built once: creating one per call made re-rendering every visible row slow. */
const fmts = new Map<string, Intl.DateTimeFormat>();
export const fmtDate = (d: number | Date, loc: string, o: Intl.DateTimeFormatOptions): string => {
  const k = loc + '|' + JSON.stringify(o);
  let f = fmts.get(k);
  if (!f) { f = new Intl.DateTimeFormat(loc, o); fmts.set(k, f); }
  return f.format(d);
};
export const tpAlt = (ms: number | null | undefined, o?: Intl.DateTimeFormatOptions): string => {
  const a = calState.a;
  if (!a || a === 'none' || !ms) return '';
  try { return fmtDate(ms, tpLoc(), { calendar: a, ...(o || { month: 'short', day: 'numeric', year: 'numeric' }) }); } catch { return ''; }
};
